import LinkWithQuery from "common/link-with-query";
import { SearchServiceItems } from 'constants/main';
import Image from 'next/image';
import Select from "react-select";
import styles from "./index.module.scss";




export default function SearchService() {

    const selectprops = {
        closeMenuOnSelect: true,
        hideSelectedOptions: false,
        blurInputOnSelect: false,
        isMulti: false,
        isRtl: true,
        noOptionsMessage: () => "داده یافت نشد!",
    };

    return (
        <section className={styles.search_contractor}>
            <div className={styles.container__serach_contractor}>
                <div className={styles.image__cover}>
                    <Image
                        src="/images/main/bg__search_services.webp"
                        alt="search service"
                        layout="fill"
                        objectFit="cover"
                        priority
                    />
                </div>
                <div className={styles.title__container}>
                    <h2>حس خوب ساختن یک خانه رویایی</h2>
                    <p>
                        اینجا کابینت ساز و نجارهای کاربلد و حرفه ای رو برای <span className='fw-600'>اجرای پروژه</span> خودت پیدا کن.
                    </p>
                </div>
                <div className={styles.search__container + " flex align-i-center"}>
                    <Select
                        {...selectprops}
                        className={styles.select__search}
                        options={SearchServiceItems}
                        placeholder="چه خدمتی احتیاج داری؟"
                        getOptionLabel={(option) => option.title}
                        getOptionValue={(option) => option.title}
                        isClearable
                        components={{
                            IndicatorSeparator: null,
                        }}
                    />


                    <LinkWithQuery
                        href={`/product?service_type=cabinet&form_type=homepage-bottom&unstructured_data=price`}
                        queryParams={["utm_source", "utm_campaign"]}
                    >
                        <button className="primary__btn">درخواست خدمت</button>
                    </LinkWithQuery>
                </div>
            </div>
        </section>
    )
}
